class FormTagService {
  constructor() {
    this.data = [
      {
        label: 'Human',
        code: '62d3a2a80000000000147cga',
      },
      {
        label: 'Animal',
        code: '62d3a2a80000000000147cgi',
      },
      {
        label: 'Non human animal',
        code: '72d3a2c90000000000147cgb',
      },
      {
        label: 'Plant',
        code: '72d3a2cf0000000000147cgc',
      },
      {
        label: 'Fungi',
        code: '72d3a2d80000000000147cgd',
      },
      {
        label: 'Protist',
        code: '72d3a2d80000000000147cge',
      },
      {
        label: 'Monera',
        code: '72d3a2d80000000000147cgf',
      },
      {
        label: 'Environmental',
        code: '72d3a2d80000000000147cgg',
      },
      {
        label: 'Others',
        code: '72d3a2d80000000000147cgh',
      },
    ];
  }

  async getList() {
    return new Promise((res) => {
      res(this.data);
    });
  }

  getOne({ id }) {
    return new Promise((res) => {
      const dept = this.data.find((datum) => datum.id === id);
      res(dept);
    });
  }
}

export default FormTagService;
